module.exports = __webpack_public_path__ + "static/media/Pista_Pena.7804a17d.png";